import { render, staticRenderFns } from "./xmxytjList.vue?vue&type=template&id=7428ddee&scoped=true&"
import script from "./xmxytjList.vue?vue&type=script&lang=js&"
export * from "./xmxytjList.vue?vue&type=script&lang=js&"
import style0 from "./xmxytjList.vue?vue&type=style&index=0&id=7428ddee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7428ddee",
  null
  
)

export default component.exports